import { render, staticRenderFns } from "./CaptainAccounting.vue?vue&type=template&id=82a8fbaa&scoped=true"
import script from "./CaptainAccounting.vue?vue&type=script&lang=js"
export * from "./CaptainAccounting.vue?vue&type=script&lang=js"
import style0 from "./CaptainAccounting.vue?vue&type=style&index=0&id=82a8fbaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a8fbaa",
  null
  
)

export default component.exports